import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, createMemoryHistory } from 'react-router';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
/*eslint-disable */
import TweenLite from 'gsap/TweenLite';
import { Power4 } from 'gsap/easing/EasePack';
/*eslint-enable */

import './js/libs/google-analytics';
import reducers from './js/reducers';

import Shell from './js/containers/shell';
import Landing from './js/containers/landing';
import Question from './js/containers/question';
import Complete from './js/containers/complete';
import Button from './js/containers/button';

// eslint-disable-next-line
import './css/app.scss';
// eslint-disable-next-line
import 'file?name=[name].[ext]!./.htaccess';

TweenLite.defaultEase = Power4.easeOut;

// eslint-disable-next-line
const store = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

ReactDOM.render(
  <Provider store={store}>
    <Router history={createMemoryHistory()}>
      <Route component={Shell}>
        <Route path="/" component={Landing} />
        <Route path="/questions" component={Question} />
        <Route path="/complete" component={Complete} />
        <Route path="/button" component={Button} />
        <Route path="*" component={Landing} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/